import React from 'react';
import FileIcon from '@wix/da-ds/pkg/Icons/24x24/File';
import VideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import StatusIcon from '@wix/da-ds/pkg/Icons/24x24/SubmitPostStatus';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { DumboProps } from '../types';
import { getDeviationType } from '../../_helpers';
import { DeviationTypes } from '../../../types/deviation';
import { useTranslation } from 'react-i18next';

import s from './NoPreviewDumbo.scss';

export type Props = Optional<DumboProps, 'deviation'>;

const NoPreviewDumbo: React.FC<Props> = ({ deviation, width, height, fileType }) => {
  const { t } = useTranslation();
  const isFilm = deviation && getDeviationType(deviation) === DeviationTypes.FILM;
  const isStatus = deviation && getDeviationType(deviation) === DeviationTypes.STATUS;
  const isUnknown = fileType === 'unknown';

  return (
    <div className={s['root']} style={{ width, height }}>
      {isFilm ? (
        <VideoIcon size={IconSize.MEDIUM} disableDefaultColors />
      ) : isStatus ? (
        <StatusIcon size={IconSize.MEDIUM} disableDefaultColors />
      ) : (
        <FileIcon size={IconSize.MEDIUM} disableDefaultColors />
      )}
      <div className={s['type']}>{isUnknown ? t('common.fileType.unknown') : fileType}</div>
    </div>
  );
};
NoPreviewDumbo.displayName = 'NoPreviewDumbo';

export default NoPreviewDumbo;
